import { render } from "./EmbroidMechine.vue?vue&type=template&id=b756968c&scoped=true"
import script from "./EmbroidMechine.vue?vue&type=script&lang=js"
export * from "./EmbroidMechine.vue?vue&type=script&lang=js"

import "./EmbroidMechine.vue?vue&type=style&index=0&id=b756968c&scoped=true&lang=css"
import "./EmbroidMechine.vue?vue&type=style&index=1&id=b756968c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b756968c"]])

export default __exports__